import { Capacitor } from '@capacitor/core';
import config from '../../config.general';
import { get } from './ApiWrapper';
import useCustomQuery from '../useCustomQuery';
import { getAppVersion, isWebApp } from '../../lib/utils';
import { staleTimeForSession, versionCheckQueryKey } from '../reactQueryCore';

export interface AppVersionCheckResult {
	status: 'ok' | 'soft-update' | 'force-update';
	message: string;
	minimumVersion: string;
	storeUrl: string;
}

const useAppVersionCheck = () => {
	const platform = Capacitor.getPlatform();
	const { appName } = config;

	return useCustomQuery<AppVersionCheckResult | null>({
		queryKey: versionCheckQueryKey(platform, appName),
		queryFn: async (): Promise<AppVersionCheckResult | null> => {
			try {
				const appVersion = await getAppVersion();
				const params = new URLSearchParams({
					platform,
					appVersion
				});

				return await get(`api/version/check?${params.toString()}`, null, false);
			} catch {
				return null;
			}
		},
		staleTime: staleTimeForSession,
		enabled: !isWebApp,
		refetchOnMount: false,
		refetchOnWindowFocus: true,
		refetchOnReconnect: true
	});
};

export default useAppVersionCheck;
